module.exports = __webpack_public_path__ + "img/nd.fc8d9f74.png";